import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

interface LayoutControlsProps {
  layoutMode: string;
  onLayoutModeChange: (mode: string) => void;
  connectorType: string;
  onConnectorTypeChange: (type: string) => void;
  layout?: 'compact' | 'full' | 'minimal';
}

export const LayoutControls: React.FC<LayoutControlsProps> = ({
  layoutMode,
  onLayoutModeChange,
  connectorType,
  onConnectorTypeChange,
  layout = 'full'
}) => {
  const { darkMode } = useTheme();

  const selectClass = `text-xs border rounded-md px-2 py-0.5 transition-all duration-200 hover:scale-105 focus:scale-105 ${
    darkMode
      ? 'bg-gray-800/80 border-green-600/50 text-white focus:border-green-400 focus:shadow-green-400/30 focus:shadow-lg backdrop-blur-sm'
      : 'bg-white/90 border-green-300/60 text-gray-900 focus:border-green-500 focus:shadow-green-300/40 focus:shadow-md backdrop-blur-sm'
  }`;

  return (
    <div className="flex items-center space-x-1 bg-gray-100/30 dark:bg-gray-800/30 rounded-lg p-0.5">
      <select
        className={selectClass}
        value={layoutMode}
        onChange={(e) => onLayoutModeChange(e.target.value)}
      >
        <option value="default">Default</option>
        <option value="hierarchical">Hierarchical</option>
        <option value="circular">Circular</option>
        <option value="force">Force</option>
        <option value="grid">Grid</option>
      </select>

      {layout !== 'minimal' && (
        <select
          className={selectClass}
          value={connectorType}
          onChange={(e) => onConnectorTypeChange(e.target.value)}
        >
          <option value="curved">Curved</option>
          <option value="straight">Straight</option>
          <option value="smoothstep">Smooth</option>
          <option value="step">Step</option>
        </select>
      )}
    </div>
  );
};
